module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAWlBMVEUAAACZmZmfn5+cnJyWlpaWlpaXl5ecnJyZmZmbm5uZmZmbm5uZmZmZmZmZmZmampqampqZmZmampqZmZmampqZmZmZmZmZmZmYmJiZmZmZmZmZmZmZmZmZmZmyPG1QAAAAHXRSTlMABRgfIicxNjc4QUqCiaWmqaq10Nbg4/Dx9vv9/hcqGF8AAABbSURBVBjTjcpHFoAgEETBNmIGTCDK/a+pDxhgae9+zWC3fmcBgK0l7MHd5q87pStYDhpTukcGvhOEjkBNEHqoA9D9WjzEfyMdNNQE7RaaIO0XPLfJZgUmmU+MLwYpCeRn8qCkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/编组.png
// module id = gxC1
// module chunks = 1